import { HTTP_DESKRH } from '@/http';
import Api from './BaseApi';


export class AdminGroupsApi extends Api {
  /**
   * The constructor for the AdminGroupsApi.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(HTTP_DESKRH, `${process.env.API_DESKRH_USERS_GROUP_ROUTE}`, parameters);
    this.searchParameters = {};
  }
  /**
   * Method used to set the search parameters.
   *
   * @param {Object} param The given parameter.
   * @param {*} value The value to be set.
   *
   * @returns {AdminGroupsApi} The instance of the AdminGroupsApi.
   */
  setSearchParam(param, value) {
    this.searchParameters[param] = value;
    return this;
  }
  /**
   * Method used to set the search parameters via an object.
   *
   * @param {Object} params The given parameter.
   *
   * @returns {AdminGroupsApi} The instance of the AdminGroupsApi.
   */
  setSearchParamObject(params) {
    this.searchParameters = params;
    return this;
  }
  /**
   * Method used to fetch all items from the API.
   *
   * @returns {Promise} The result in a promise.
   */
  all() {
    const searchParameters = this.searchParameters;
    return this.submit('post', `/${this.endpoint}s`, searchParameters)
      .then((response) => {
        let totalPages = Math.ceil(response.data.count / this.searchParameters.limit);
        if (totalPages === 0) {
          totalPages = 1;
        }
        return {
          data: response.data.groups,
          pagination: {
            limit: searchParameters.limit,
            totalCount: response.data.count,
            totalPages,
          },
        };
      });
  }
}

export const adminGroupsApi = new AdminGroupsApi();



// WEBPACK FOOTER //
// ./src/api/AdminGroupsApi.js